export interface EventAttendee {
  firstName: string;
  lastName: string;
  eventName: string;
}
